/* スムーズスクロール */
$(window).on('load', function () {
  var locUrl = location.href;
  var setHash = locUrl.split('#');
  //現在のページURLに#が含まれる場合はスクロール移動
  if (setHash[1]) {
    hashMove("#" + setHash[1]);
  }
  //#pagetop
  $('#pagetop a').on('click', function () {
    var href = $(this).attr("href");
    var clkUrl = href.split('#');
    hashMove("#" + clkUrl[1]);
    return false;
  });
  //#から始まるリンクはスクロール
  $('a[href^="#"]').on('click', function () {
    var href = $(this).attr("href");
    var clkUrl = href.split('#');
    hashMove("#" + clkUrl[1]);
  });
  //#を含むリンクは、リンク先と現在のページのURLを比較して判断
  $('a[href*="#"]').on('click', function () {
    var href = $(this).attr("href");
    var pageURL = location.pathname;
    reg = new RegExp(pageURL);
    //ページ名が同じならスクロール移動
    if (href.match(reg)) {
      var clkUrl = href.split('#');
      hashMove("#" + clkUrl[1]);
    }
  });

  function hashMove(trg) {
    var position = $(trg).offset().top;
    if ($('body').hasClass('admin-bar')) {
      position = position - 50;
    } else {
      position = position - 20;
    }
    if ($('body').width() <= 980) {
      position = position - 50; //見出しの文字が切れるのを防ぐ
    } else {
      position = position - 50; //見出しの文字が切れるのを防ぐ
    }
    $('body,html').animate({ scrollTop: position }, '800', 'swing');
    return false;
  }
});

let $pagetop = $('#icon_fixed_cart');
$(window).on('scroll', function () {
  //スクロール位置を取得
  if ($(this).scrollTop() < 150) {
    $pagetop.removeClass('active');
  } else {
    $pagetop.addClass('active');
  }
});

// ご利用案内
$(function () {
  $(".common_nav_guide_box .title").on('click', function () {
    $(this).next("div").slideToggle();
    var now_id = $(this).attr("id");
    if (now_id == "open") {
      $(this).attr("id", "close");
    } else {
      $(this).attr("id", "open");
    }
  });
});

// 生産者バナーカルーセル
/*var galleryTop1 = new Swiper(".top_bnr_vender", {
  slidesPerView: 1,
  spaceBetween: 10,
  slidesPerView: 1.2,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      centeredSlides: false,
      slidesPerView: 3,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  },
});*/

// 特集バナーカルーセル
var galleryTop2 = new Swiper(".top_bnr_feature", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 3,
      spaceBetween: 35,
    },
  },
});

// ガイド系バナーカルーセル
var galleryTop3 = new Swiper(".top_bnr_guide", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 3,
      spaceBetween: 35,
    },
  },
});

// シーン系バナーカルーセル
var galleryTop4 = new Swiper(".top_bnr_scene", {
  loop: true,
  slidesPerView: 2,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 4,
      spaceBetween: 0,
    },
  },
});

// collection系バナーカルーセル
var galleryTop5 = new Swiper(".top_meat_move", {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 0,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 8,
    },
  },
});

// お肉の種類で選ぶ
var galleryTop_vendar = new Swiper(".choice_meat_pc_container", {
  spaceBetween: 15,
  slidesPerView: 8,
  //slidesPerGroup: 8,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: '.swiper-button-meat-next',
    prevEl: '.swiper-button-meat-prev',
  },
});

// 食べ方から選ぶ
var galleryTop_vendar = new Swiper(".choice_eat_pc_container", {
  spaceBetween: 15,
  slidesPerView: 6,
  //slidesPerGroup: 6,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: '.swiper-button-eat-next',
    prevEl: '.swiper-button-eat-prev',
  },
});

// 生産者
var galleryTop_vendar = new Swiper(".vendar_pc_container", {
  spaceBetween: 15,
  slidesPerView: 6,
  //slidesPerGroup: 6,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  navigation: {
    nextEl: '.swiper-button-vender-next',
    prevEl: '.swiper-button-vender-prev',
  },
});

// 切り口
/*var galleryTop_vendar = new Swiper(".chice_select_pc_container", {
  slidesPerView: 1,
  spaceBetween: 0,
  slidesPerView: 9,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});*/

// 過去の特集一覧
var galleryTop_fv = new Swiper(".common_feature_container", {
  spaceBetween: 10,
  slidesPerView: 1.3,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      spaceBetween: 20,
      slidesPerView: 2,
      centeredSlides: false,
      navigation: {
        nextEl: ".swiper-button-feature-next",
        prevEl: ".swiper-button-feature-prev",
      },
    },
  },
});

// お肉の種類で選ぶ　新レイアウト
/*$(function () {
  $('.select_meattype_box label').on('click', function () {
    $('.select_meattype_list.open .select_meattype_list').slideUp(300);
    $('.select_meattype_box').removeClass('open');
    $(this).parent('.select_meattype_box').addClass('open');
    $(this).next('.select_meattype_list').slideToggle(300);
  })
});*/
$(function () {
  $(".select_meattype_box label").on('click', function () {
    $(".open").not($(this).parent('.select_meattype_box')).removeClass("open");
    $(".select_meattype_box label .select_meattype_box").not($(this).next(".select_meattype_box")).slideUp(300);
    $(this).parent('.select_meattype_box').toggleClass("open");
    $(this).next(".select_meattype_box").slideToggle(300);
  });
});

// お客様の声
$(function () {
  $(".btn_voice").on("click", function () {
    $(this).prev("ul").toggleClass("open");
    $(this).toggleClass("close");
    var now_class = $(this).attr("class");
    if (now_class == 'btn_voice close') {
      $(this).children('span').html("閉じる");
    } else {
      $(this).children('span').html("お客様の声をもっと見る");
    }
  })
})

// お客様の声
var galleryTop_pickup = new Swiper(".uservoice_img_outer", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 10,
  centerSlides: true,
  centerInsufficientSlides: true,
  pagination: {
    el: ".swiper-pagination", //ページネーションの要素
    type: "bullets", //ページネーションの種類
    clickable: true, //クリックに反応させる
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      navigation: {
        nextEl: ".swiper-button-voice-next",
        prevEl: ".swiper-button-voice-prev",
      },
    },
  },
});


//現在の年数オブジェクトを4桁で生成
var regi_time = new Date();
var regi_year = regi_time.getFullYear();
//1900年まで表示
for (var i = regi_year; i >= 1900; i--) {
  $("#customer_year").append('<option value="' + i + '">' + i + "</option>");
}
//1～12の数字を生成
for (var i = 1; i <= 12; i++) {
  $("#customer_month").append('<option value="' + i + '">' + i + "</option>");
}
//1～31の数字を生成
for (var i = 1; i <= 31; i++) {
  $("#customer_day").append('<option value="' + i + '">' + i + "</option>");
}
